import React, { useRef } from 'react'
import classnames from 'classnames'
import { useInViewport } from 'ahooks'
import * as styles from './index.module.less'

interface SectionProps {
  className?: string
  children?: React.ReactNode
  title: string
  mask_bg: string
  mask_className?: string
}

const Section: React.FC<SectionProps> = ({ className, children, title, mask_bg, mask_className }) => {
  const ref = useRef(null)
  const [inViewport] = useInViewport(ref)
  return (
    <section
      ref={ref}
      className={classnames('lg:py-[90px] py-[40px]', styles.section, { [styles['visible']]: inViewport }, className)}
    >
      <h2 className="text-center relative mb-[32px] lg:mb-[90px]">
        <img
          className={classnames(
            'absolute lg:h-[90px] h-[60px] left-1/2 translate-x-[-50%]  top-[-12px]',
            mask_className,
          )}
          src={mask_bg}
          alt={title}
        />
        <span className={styles.title}>{title}</span>
      </h2>
      {children}
    </section>
  )
}

export default Section
